module.exports = __webpack_public_path__ + "img/Close - Pink - Selected.298b552d.png";